export default "__VITE_ASSET__kjT43sdV__"